// extracted by mini-css-extract-plugin
export default {"button":"TabButton_button__d+Dyk"};